// extracted by mini-css-extract-plugin
export default {"hyphens":"b_c79","linkCard":"QfDqJ","link":"zf50_","title":"ZOidi b_c79","introduction":"Xm_ZO","images":"ffHqd"};